import { startPageBreadcrumbs } from './config/breadcrumbs';
import styles from '../Dashboard/Dashboard.module.css';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { icons } from '@/assets';
import { useMemo } from 'react';

const FleetDashboard = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => startPageBreadcrumbs(navigate), []);

  return (
    <section className={styles.container}>
      <div className='w-full flex flex-col items-start'>
        <NavigateLinks actualPage='Flota' breadcrumbs={breadcrumbs} />
      </div>
      <ul className={styles.modules}>
        <li
          className={styles.module}
          onClick={() => navigate('/fleet/assignment')}
        >
          <img src={icons.assignment} alt='Icono de Asignaciones' />
          <p>Asignaciones</p>
        </li>
        <li
          className={styles.module}
          onClick={() => navigate('/fleet/dashboard')}
        >
          <img src={icons.monitor} alt='Icono de Dashboard' />
          <p>Dashboard</p>
        </li>
        <li
          className={styles.module}
          onClick={() => navigate('/fleet/drivers')}
        >
          <img src={icons.drivers} alt='Icono de Conductores' />
          <p>Conductores</p>
        </li>
        <li
          className={styles.module}
          onClick={() => navigate('/fleet/vehicles')}
        >
          <img src={icons.vehicles} alt='Icono de Vehículos' />
          <p>Vehículos</p>
        </li>
        <li
          className={styles.module}
          onClick={() => navigate('/fleet/companies')}
        >
          <img src={icons.company} alt='Icono de Compañía' />
          <p>Compañías</p>
        </li>
        <li className={styles.module} onClick={() => navigate('/fleet/costs')}>
          <img src={icons.cost} alt='Icono de Costos' />
          <p>Costos</p>
        </li>
        <li
          className={styles.module}
          onClick={() => navigate('/fleet/services')}
        >
          <img src={icons.serviceHistory} alt='Icono de Servicios' />
          <p>Servicios</p>
        </li>
      </ul>
    </section>
  );
};

export default FleetDashboard;
